import { Link, useNavigate } from 'react-router-dom'
import { UserPlus } from 'lucide-react'
import { useState } from 'react'
import { Button } from '@/components/ui'
import { useAuth } from '@/contexts/AuthContext'

export function RegisterPage() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  
  const navigate = useNavigate()
  const { refreshUser } = useAuth()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setIsLoading(true)

    try {
      const res = await fetch('/api/auth/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, password })
      })

      const data = (await res.json()) as any
      
      if (!res.ok || !data.success) {
        if (data.error?.fields) {
          const firstError = Object.values(data.error.fields)[0]
          setError(Array.isArray(firstError) ? firstError[0] : 'Input tidak valid.')
        } else {
          setError(data.error?.message || 'Gagal mendaftar.')
        }
        return
      }

      await refreshUser()
      navigate('/businesses')
    } catch (err) {
      setError('Terjadi kesalahan jaringan.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="animate-fade-in">
      <div className="mb-8 text-center">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-brand-500/10 border border-brand-500/20 mb-4">
          <UserPlus size={22} className="text-brand-400" />
        </div>
        <h1 className="text-xl font-bold text-slate-100">Buat Akun</h1>
        <p className="text-sm text-slate-500 mt-1">Mulai kelola bisnis UMKM Anda</p>
      </div>

      {error && (
        <div className="mb-4 p-3 bg-red-500/10 border border-red-500/20 rounded-lg text-red-400 text-sm text-center">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-xs font-medium text-slate-400 mb-1.5" htmlFor="register-name">
            Nama Lengkap
          </label>
          <input
            id="register-name"
            type="text"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Nama Anda"
            className="w-full h-10 px-3 rounded-lg bg-slate-800/60 border border-slate-700 text-slate-100 text-sm placeholder:text-slate-600 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-colors"
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-slate-400 mb-1.5" htmlFor="register-email">
            Email
          </label>
          <input
            id="register-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="founder@bisnis.com"
            className="w-full h-10 px-3 rounded-lg bg-slate-800/60 border border-slate-700 text-slate-100 text-sm placeholder:text-slate-600 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-colors"
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-slate-400 mb-1.5" htmlFor="register-password">
            Password
          </label>
          <input
            id="register-password"
            type="password"
            required
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Min. 8 karakter"
            className="w-full h-10 px-3 rounded-lg bg-slate-800/60 border border-slate-700 text-slate-100 text-sm placeholder:text-slate-600 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-colors"
          />
        </div>

        <Button id="register-submit" type="submit" className="w-full" size="md" disabled={isLoading}>
          {isLoading ? 'Memproses...' : 'Buat Akun'}
        </Button>
      </form>

      <div className="mt-6 text-center space-y-2">
        <p className="text-xs text-slate-600">
          Sudah punya akun?{' '}
          <Link to="/login" className="text-brand-400 hover:text-brand-300 transition-colors font-medium">
            Masuk
          </Link>
        </p>
      </div>
    </div>
  )
}
